// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JzTo","col":"styles_col__1Qob7","actions":"styles_actions__3oJaz","conflict":"styles_conflict__hJaGV"};